// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__357Vv","right":"styles_right__2fMiN"};